module.exports = __webpack_public_path__ + "static/media/image-not-found-bis.7640aca1.jpg";